export default __webpack_public_path__ + "static/media/006-crossbow.319bde91.svg";